export enum BadgeType {
    RFID = 'RFID',
    HID = 'HID',
    LICENCE_PLATE = 'LICENCE_PLATE',
    QR_CODE = 'QR_CODE',
    UNKNOWN = 'UNKNOWN'
}
